// libs

// icons
import AppSettingsAltIcon from '@mui/icons-material/AppSettingsAlt';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PinIcon from '@mui/icons-material/Pin';
import {
  alpha,
  Button,
  Chip,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

// assets
import { BreadcrumbWithCopyToClipboard } from './BreadcrumWithCopyToClipboard';
import { enterConsultationView, exitConsultationView } from 'FRONTEND/reducers/consultationViewSlice';
import i18n from 'FRONTEND/utils/i18n';

const Breadcrumbs = ({
  parentPages,
  currentPage,
  site,
  updatedAt,
  interventionConsultations,
  cloudAccessCode,
  isTestingConsultation = true,
  medcaptureClientVersion,
  parsysId,
}) => {
  /**
   * Breadcrumb trail on consultation page.
   */
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(enterConsultationView());
    return () => {
      dispatch(exitConsultationView());
    };
  }, []);

  const handleDropDownClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  return (
    <>
      <Stack direction='row' align-items='start' flexWrap='wrap' spacing={1} width='100%'>
        {parentPages.map(({ label, toggle, target, icon }) => (
          <Stack
            key={label}
            alignItems='center'
            justifyContent='center'
            spacing={1}
            direction='row'
          >
            <Button
              type='button'
              component='button'
              data-toggle={toggle}
              data-target={target}
              startIcon={icon}
              sx={{
                fontSize: '18px',
              }}
            >
              {label}
            </Button>
            <span>{'>'}</span>
          </Stack>
        ))}
        <Stack spacing={1} direction='row' alignItems='flex-start' justifyContent='start' flexWrap='nowrap' width='100%'>
          <span style={{ paddingTop: '2px' }}>{currentPage.icon}</span>
          <Stack direction='row' alignItems='flex-start' spacing={1} flexWrap='wrap' flexShrink={1} minWidth={0}>
            <Typography variant='button'>{currentPage.label}</Typography>
            <Chip
              label={currentPage.status}
              sx={(theme) => ({
                fontSize: '16px',
                height: '28px',
                backgroundColor: theme.palette.grey[700],
                color: theme.palette.getContrastText(theme.palette.grey[700]),
              })}
            />
            {isTestingConsultation && (
              <Chip
                label={i18n._('Test')}
                sx={(theme) => ({
                  fontSize: '16px',
                  height: '28px',
                  backgroundColor: (theme) => alpha(theme.palette.success.light, 0.3),
                  color: 'success.main',
                })}
              />
            )}
          </Stack>
          <Stack ml='auto' flex={1}>
            {cloudAccessCode &&
              (
                <BreadcrumbWithCopyToClipboard
                  label={i18n._('Access code')}
                  value={cloudAccessCode}
                  startIcon={<PinIcon fontSize='12px' />}
                />
              )}
            {medcaptureClientVersion && (
              <BreadcrumbWithCopyToClipboard
                label={i18n._('Medcapture')}
                value={medcaptureClientVersion}
                startIcon={<AppSettingsAltIcon fontSize='12px' />}
              />
            )}
            {parsysId && (
              <BreadcrumbWithCopyToClipboard
                label={i18n._('Parsys ID')}
                value={parsysId}
                startIcon={<FingerprintIcon fontSize='12px' />}
              />
            )}
          </Stack>
        </Stack>
        {updatedAt &&
          <div className='breadcrumbs-draftLastUpdate'>
            <Typography variant='overline'>{`(${i18n._('Last updated on')} ${updatedAt})`}</Typography>
          </div>}
        {(interventionConsultations && interventionConsultations.length > 0) &&
          <>
            <Button
              onClick={handleDropDownClick}
              variant='contained'
              color='inherit'
              endIcon={<KeyboardArrowDownIcon />}
            >
              {i18n._('Intervention')}
            </Button>
            <Menu
              open={Boolean(menuAnchorEl)}
              anchorEl={menuAnchorEl}
              onClose={handleMenuClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              {interventionConsultations.map(consultation => (
                <MenuItem
                  key={consultation.label}
                  component='a'
                  onClick={handleMenuClose}
                  href={consultation.link}
                  data-pjax
                >
                  {consultation.label}
                </MenuItem>
              ))}
            </Menu>
          </>}
      </Stack>
      {site && <div><iframe id='breadcrumbs-site' src={site} /></div>}
    </>
  );
};

export default Breadcrumbs;
